import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Crown = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M17.21 9.45119L12.83 2.89119C12.64 2.61119 12.32 2.47119 12 2.47119C11.68 2.47119 11.36 2.61119 11.17 2.90119L6.79 9.45119H2C1.45 9.45119 1 9.90119 1 10.4512C1 10.5412 1.01 10.6312 1.04 10.7212L3.58 19.9912C3.81 20.8312 4.58 21.4512 5.5 21.4512H18.5C19.42 21.4512 20.19 20.8312 20.43 19.9912L22.97 10.7212L23 10.4512C23 9.90119 22.55 9.45119 22 9.45119H17.21ZM9 9.45119L12 5.05119L15 9.45119H9ZM12 17.4512C10.9 17.4512 10 16.5512 10 15.4512C10 14.3512 10.9 13.4512 12 13.4512C13.1 13.4512 14 14.3512 14 15.4512C14 16.5512 13.1 17.4512 12 17.4512Z"
    />
  </svg>
);
